import styled from "styled-components";

export const DocumentsWrapper = styled.div`
  border-radius: 10px;
  background: ${({ theme }) => theme.card.bg.secondary};
  padding: 20px 15px;

  .documents-header {
    margin-bottom: 16px;

    h2 {
      font-family: Geist, sans-serif;
      font-size: 18px;
      font-weight: 500;
      line-height: 28px;
      color: rgb(24, 29, 39);
      margin: 0 0 4px;
    }

    p {
      font-family: "Geist", sans-serif;
      font-size: 13px;
      color: ${({ theme }) => theme.card.font.tertiary};
      margin: 0;
    }
  }

  .table-scroll-wrapper {
    max-height: 580px;
    overflow-y: auto;
  }
`;
